import { useState, useLayoutEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { gaEnabled, hasConsentChoice, setConsent } from "@/lib/analytics";

// Minimal, brand-styled cookie-consent banner (DPDP). Only shown when analytics
// is enabled and the visitor hasn't chosen yet. Analytics stays denied until Accept.
export default function ConsentBanner() {
  const [show, setShow] = useState(() => gaEnabled() && !hasConsentChoice());
  const ref = useRef(null);

  // Publish the banner's height as --consent-h so the floating "Ask a Spotter"
  // launcher can lift clear of it (they both pin to the bottom edge). Cleared
  // when the banner goes away.
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (!show) { root.style.setProperty("--consent-h", "0px"); return; }
    const set = () => root.style.setProperty("--consent-h", `${ref.current?.offsetHeight || 0}px`);
    set();
    window.addEventListener("resize", set);
    return () => { window.removeEventListener("resize", set); root.style.setProperty("--consent-h", "0px"); };
  }, [show]);

  if (!show) return null;
  const choose = (granted) => { setConsent(granted); setShow(false); };
  return (
    <div ref={ref} className="fixed inset-x-0 bottom-0 z-[60] bg-foreground text-background">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <p className="text-sm max-w-2xl">
          We use cookies to understand how the site is used and improve it. See our{" "}
          <Link to="/legal/privacy" className="underline hover:text-[hsl(var(--accent))]">Privacy Policy</Link>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button onClick={() => choose(false)}
            className="border border-background/40 px-5 py-2 font-mono text-[11px] uppercase tracking-widest hover:bg-background/10">Decline</button>
          <button onClick={() => choose(true)}
            className="bg-background text-foreground px-5 py-2 font-mono text-[11px] uppercase tracking-widest hover:bg-[hsl(var(--accent))] hover:text-background">Accept</button>
        </div>
      </div>
    </div>
  );
}
